import { render, staticRenderFns } from "./TaxesPayLtda2.vue?vue&type=template&id=ba398e7e&scoped=true&"
import script from "./TaxesPayLtda2.vue?vue&type=script&lang=js&"
export * from "./TaxesPayLtda2.vue?vue&type=script&lang=js&"
import style0 from "./TaxesPayLtda2.vue?vue&type=style&index=0&id=ba398e7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba398e7e",
  null
  
)

export default component.exports